import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import { localizedPath } from '../i18n/config';
import { useLocale } from '../i18n/useLocale';
import { Logo } from './Logo';
import { SignInLabel } from './SignInLabel';

export function SiteFooter() {
  const { t } = useTranslation();
  const locale = useLocale();
  const home = localizedPath(locale, '/');

  return (
    <footer className="site-footer">
      <div className="container site-footer-inner">
        <div>
          <Logo />
          <p className="site-footer-note">{t('footer.tagline')}</p>
        </div>
        <nav aria-label={t('nav.footer')} className="site-footer-nav">
          <Link to={localizedPath(locale, '/models')}>{t('nav.models')}</Link>
          <a href={`${home}#prices`}>{t('nav.prices')}</a>
          <Link to={localizedPath(locale, '/docs')}>{t('nav.docs')}</Link>
          <a href={`${home}#referrals`}>{t('nav.referrals')}</a>
          <a href={`${home}#faq`}>{t('nav.faq')}</a>
          <Link to="/app">
            <SignInLabel />
          </Link>
        </nav>
        <p className="site-footer-copy">© 2026 LowCostRouter</p>
      </div>
    </footer>
  );
}
